import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchPosts = () => api.get("/posts").then((r) => r.data);
export const fetchPost = (slug) => api.get(`/posts/${slug}`).then((r) => r.data);
export const submitQuote = (payload) => api.post("/contact", payload).then((r) => r.data);
